import { md5 as JSMd5 } from 'js-md5';
import { Dexie, type EntityTable } from 'dexie';

export const INDEXED_DB_NAME = 'MateApiCache';

interface CacheData {
  data: any;
  md5: string;
  updatedAt: number;
  key: string;
}
type Md5Callback = (data: any) => string;
export const revalidateCache = async (
  key: string,
  apiRequest: Promise<any>,
  onRevalidated: (data: any) => void,
  onRevalidateFail?: (error: any) => void,
  md5?: string | Md5Callback
) => {
  const db = new Dexie(INDEXED_DB_NAME) as Dexie & {
    caches: EntityTable<CacheData, 'md5'>;
  };
  try {
    db.version(1).stores({
      caches: 'key',
    });
    const cache = await db.caches
      .where({
        key,
      })
      .first();
    const revalidate = () => {
      return apiRequest
        .then(async (data) => {
          const jsonData = JSON.stringify(data);
          let md5Data = '';
          if (md5) {
            if (typeof md5 === 'function') {
              md5Data = md5(data);
            } else {
              md5Data = md5;
            }
          } else {
            md5Data = JSMd5.create().update(jsonData).hex();
          }
          if (cache) {
            if (cache.md5 !== md5Data) {
              console.log(
                key,
                'cache outdated, revalidate',
                'from',
                cache.md5,
                'to',
                md5Data
              );
              await db.caches.update(cache.key, {
                data: jsonData,
                md5: md5Data,
                updatedAt: Date.now(),
                key,
              });
              onRevalidated(JSON.parse(jsonData));
            } else {
              await db.caches.update(cache.key, {
                data: jsonData,
                md5: md5Data,
                updatedAt: Date.now(),
                key,
              });
            }
          } else {
            console.log(key, 'cache not found, set cache');
            await db.caches.add({
              data: jsonData,
              md5: md5Data,
              updatedAt: Date.now(),
              key,
            });
            return JSON.parse(jsonData);
          }
        })
        .catch((e) => {
          console.error('revalidate fail', e);
          if (!cache?.data) {
            throw e;
          } else {
            onRevalidateFail && onRevalidateFail(e);
            return;
          }
        });
    };

    if (cache) {
      revalidate();
      console.log(key, 'cache hit');
      return Promise.resolve(JSON.parse(cache.data));
    } else {
      console.log(key, 'cache miss');
      return revalidate();
    }
  } catch (e) {
    console.warn('revalidateCache error', e);
    return apiRequest;
  }
};

export const removeCacheDB = async () => {
  try {
    const db = new Dexie(INDEXED_DB_NAME) as Dexie & {
      caches: EntityTable<CacheData, 'md5'>;
    };
    await db.delete();
  } catch (e) {
    console.warn('revalidateCache delete error', e);
  }
};
